import React, { useEffect, useMemo, useState } from 'react'
import { alertActions, coinManagementActions, kycVerificationListActions, userManagementActions } from '../../../_actions';
import SubMerchantApproved from './SubMerchantApproved';
import SubMerchantPending from './SubMerchantPending';
import SubMerchantDecline from './SubMerchantDecline';
import { useDispatch, useSelector } from 'react-redux';
import StatBadge from '../../../components/Atoms/State Badge/StatBadge';
import ViewHistoryModal from '../../../components/Atoms/popup/ViewHistoryModal';
import Loader from '../../../components/Atoms/Loader';
import SubMerchantMoreInfo from './SubMerchantMoreInfo';
import SubMerchantVerify from './SubMerchantVerify';
import { useNavigate, useLocation } from 'react-router-dom';
import StatusPopup from '../../../components/Atoms/popup/Popup';

const SubMerchantsApproval = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    // Get query parameters from URL
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get('tab');
    const pageParam = queryParams.get('page');

    const { userManagement: { getWebStoreData, loading } } = useSelector(state => state)
    const { list, total } = getWebStoreData ? getWebStoreData : {}

    const [selectedData, setSelectedData] = useState(null);
    const [modalState, setModalState] = useState({
        isPending: false,
        isApprove: false,
        isMoreInfo: false,
        isView: false, isVerify: false
    });
    const [value, setValue] = useState('');
    const [count, setCount] = useState(null);
    const [isLoading, setIsLoading] = useState(false)

    // Set initial tab from URL params or default
    const [activeTab, setActiveTab] = useState(tabParam || 'sub-merchant-pending');
    const size = 5;
    const [pageNo, setPageNo] = useState(pageParam ? parseInt(pageParam) : 1);

    // Update URL when tab or page changes
    const updateUrlParams = (tab, page) => {
        const params = new URLSearchParams();
        params.set('tab', tab);
        navigate({
            pathname: location.pathname,
            search: params.toString()
        });
    };

    // Update URL whenever activeTab or pageNo changes
    useEffect(() => {
        updateUrlParams(activeTab);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab]);

    const fetchCount = () => {
        coinManagementActions.getAmountAndCount({ type: 'MERCHANT_APPS' })
            .then(res => res && setCount(res?.data))
            .catch(console.error);
    };

    useEffect(() => {
        fetchCount();
    }, []);

    const tabConfig = useMemo(() => [
        {
            id: 'sub-merchant-pending',
            label: 'Pending',
            count: count?.pendingSubMerchants || "0",
            apiStatus: 'pending',
            component: () => <SubMerchantPending data={list} handleAction={handleAction} handleSubmit={handleSubmit} toggleModal={toggleModal} value={value}
                setValue={setValue} isApproveModal={modalState.isApprove} isPendingModal={modalState.isPending} isMoreInfoModal={modalState.isMoreInfo}
                size={size} pageNo={pageNo} total={total} onPageChange={onPageChange} count={count?.pendingSubMerchants} />
        },
        {
            id: 'sub-merchant-approved',
            label: 'Approval',
            count: count?.approvedSubMerchants || "0",
            apiStatus: 'approved',
            component: () => <SubMerchantApproved data={list} handleAction={handleAction} size={size} pageNo={pageNo} total={total} onPageChange={onPageChange} count={count?.approvedSubMerchants} />
        },
        {
            id: 'sub-merchant-rejected',
            label: 'Declined',
            count: count?.rejectedSubMerchants || "0",
            apiStatus: 'rejected',
            component: () => <SubMerchantDecline data={list} handleAction={handleAction} size={size} pageNo={pageNo} total={total} onPageChange={onPageChange} count={count?.rejectedSubMerchants} />
        },
        {
            id: 'sub-merchant-more-info',
            label: 'more info',
            count: count?.moreInfoSubMerchants || "0",
            apiStatus: 'more-info',
            component: () => <SubMerchantMoreInfo data={list} handleAction={handleAction} size={size} pageNo={pageNo} total={total} onPageChange={onPageChange} count={count?.moreInfoSubMerchants} />
        },
        {
            id: 'verified-merchant',
            label: 'Verified',
            count: count?.verifiedSubMerchants || "0",
            apiStatus: 'verified-merchant',
            component: () => <SubMerchantVerify data={list} handleAction={handleAction} size={size} pageNo={pageNo} total={total} onPageChange={onPageChange} count={count?.verifiedSubMerchants} />
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ], [list, count, value, modalState, pageNo]);

    const currentTab = tabConfig.find(tab => tab.id === activeTab) || tabConfig[0];

    const fetchKycList = () => {
        dispatch(userManagementActions.getWebStoreList({
            "keyWord": "",
            "pageNo": pageNo,
            "size": size,
            "userId": "",
            "isSubStore": true,
            status: currentTab.apiStatus
        }))
    };

    useEffect(() => {
        fetchKycList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, pageNo, size]);

    const handleTabChange = tabId => {
        setActiveTab(tabId);
        setPageNo(1); // Reset page number when changing tabs
    };

    const handleAction = (action, data) => {
        setSelectedData(data);
        const newState = {
            isPending: false,
            isApprove: false,
            isMoreInfo: false,
            isView: false, isVerify: false
        };

        switch (action) {
            case 'PENDING':
                newState.isPending = true;
                break;
            case 'APPROVE':
                newState.isApprove = true;
                break;
            case 'VERIFY':
                newState.isVerify = true;
                break;
            case 'MORE_INFO':
                newState.isMoreInfo = true;
                break;
            case 'VIEW':
                newState.isView = true;
                setIsLoading(true)
                kycVerificationListActions.viewRejectionsReasonsForMerchantKyc({ id: data?._id })
                    .then(res => res && setSelectedData(res.data))
                    .catch(console.error).finally(() => {
                        setIsLoading(false)
                    });
                break;
            default:
                break;
        }
        setModalState(newState);
    };

    const toggleModal = (action) => {
        const newState = { ...modalState };
        // eslint-disable-next-line default-case
        switch (action) {
            case 'PENDING':
                newState.isPending = false;
                break;
            case 'APPROVE':
                newState.isApprove = false;
                break;
            case 'VERIFY':
                newState.isVerify = false;
                break;
            case 'MORE_INFO':
                newState.isMoreInfo = false;
                break;
            case 'VIEW':
                newState.isView = false;
                break;
        }
        setModalState(newState);
        setSelectedData(null);
        setValue('');
    };

    const handleSubmit = async (e, action) => {
        e?.preventDefault?.();
        const payload = {
            id: selectedData?._id,
            status: '',
            ...(value && { reason: value })
        };

        if (action === 'Pending') payload.status = 'rejected';
        if (action === 'Approve') payload.status = 'approved';
        if (action === 'More-Info') payload.status = 'more-info';

        try {
            setIsLoading(true);
            const res = await kycVerificationListActions.approveOrRejectSubMerchant(payload);
            if (res) {
                const msg = res?.data?.message || res?.message || "Sub merchant status updated successfully";
                dispatch(alertActions.success(msg));
                fetchKycList();
                fetchCount();
                setModalState({ isPending: false, isApprove: false, isMoreInfo: false, isView: false, isVerify: false });
                setSelectedData(null);
                setValue('');
            }
        } catch (error) {
            console.error(error);
            dispatch(alertActions.error(error?.message || error || "Failed to update sub merchant status"));
            setModalState({ isPending: false, isApprove: false, isMoreInfo: false, isView: false, isVerify: false });
            setSelectedData(null);
            setValue('');
        } finally {
            setIsLoading(false);
        }
    };

    const onPageChange = (pageNo) => {
        setPageNo(pageNo);
    }

    const handleSubmitVerify = () => {
        setIsLoading(true)
        kycVerificationListActions.convertToVerifiedMerchant({
            "id": selectedData?._id,
            "isStore": true
        }).then((res) => {
            if (res) {
                const msg = res?.data?.message || res?.message || "Merchant verified successfully";
                dispatch(alertActions.success(msg));
                coinManagementActions.getAmountAndCount({ type: 'MERCHANT_APPS' })
                    .then(res => res && setCount(res?.data))
                    .catch(console.error);
                fetchKycList();
                setModalState({ isPending: false, isApprove: false, isMoreInfo: false, isView: false, isVerify: false });
                setSelectedData(null);
                setIsLoading(false)
            }
        }).catch((error) => {
            dispatch(alertActions.error(error))
        }).finally(() => {
            setIsLoading(false)
        })
    }


    return (
        <div className="p-4 overflow-auto">
            <Loader loading={loading || isLoading} />
            <div className="p-3">
                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
                    <h1 className="text-xl font-bold text-gray-800 whitespace-nowrap">Sub Merchant Apps</h1>

                    <div className="w-full lg:w-auto">
                        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-5 gap-2">
                            {tabConfig.map(tab => (
                                <StatBadge
                                    key={tab.id}
                                    label={`${tab.label} : ${tab.count}`}
                                    isActive={activeTab === tab.id}
                                    onClick={() => handleTabChange(tab.id)}
                                    className="w-full"
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-3">{currentTab.component()}</div>

            <ViewHistoryModal
                isOpen={modalState.isView}
                onClose={() => toggleModal('VIEW')}
                data={selectedData}
                heading="More Info"
                isLoading={isLoading}
            />

            <StatusPopup isOpen={modalState.isVerify} onClose={() => toggleModal('VERIFY')} heading={`Are You Sure Want To Verify !`} onConfirm={handleSubmitVerify} />
        </div>
    )
}

export default SubMerchantsApproval